import { Card, CardContent, Typography } from '@material-ui/core'

interface IStatCardProps {
  title: string
  value: string
  color?: string
  gradientColors?: [string, string]
}

export const StatCard = ({
  title,
  value,
  color = '#2549CC',
  gradientColors,
}: IStatCardProps) => (
  <Card
    style={{
      flex: 1,
      background: gradientColors
        ? `linear-gradient(135deg, ${gradientColors[0]} 0%, ${gradientColors[1]} 100%)`
        : undefined,
    }}
  >
    <CardContent style={{ padding: '24px' }}>
      <Typography
        variant="h6"
        style={{ color, marginBottom: '8px', fontSize: '14px', fontWeight: 600 }}
      >
        {title}
      </Typography>
      <Typography variant="h4" style={{ color, fontWeight: 700, marginBottom: '4px' }}>
        {value}
      </Typography>
    </CardContent>
  </Card>
)






